import React, { useEffect, useState } from 'react';

const API_BASE = '/api';

interface PreviewModalProps {
  documentId: string;
  title: string;
  onClose: () => void;
}

function PreviewModal({ documentId, title, onClose }: PreviewModalProps) {
  const [loading, setLoading] = useState(true);
  const [previewAvailable, setPreviewAvailable] = useState(false);
  const previewUrl = `${API_BASE}/documents/${documentId}/preview`;

  useEffect(() => {
    setLoading(true);
    fetch(`${API_BASE}/documents/${documentId}`, { credentials: 'include' })
      .then((res) => res.json())
      .then((doc) => {
        const v = doc.current_version;
        const canPreview = v && (v.mime_type === 'application/pdf' || v.has_preview || v.mime_type?.startsWith('image/'));
        setPreviewAvailable(!!canPreview);
      })
      .finally(() => setLoading(false));
  }, [documentId]);

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal modal-large" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>{title}</h2>
          <div className="modal-header-actions">
            <a
              href={`${API_BASE}/documents/${documentId}/download`}
              className="btn-secondary"
              title="Download original file"
            >
              Download
            </a>
            <button className="modal-close" onClick={onClose}>&times;</button>
          </div>
        </div>

        {loading && <p>Loading preview...</p>}

        {!loading && previewAvailable && (
          <iframe
            src={`${previewUrl}#toolbar=0&navpanes=0`}
            title={title}
            className="preview-frame"
          />
        )}

        {!loading && !previewAvailable && (
          <div className="preview-fallback">
            <p>No in-app preview available for this file type.</p>
            <a href={`${API_BASE}/documents/${documentId}/download`} className="btn-primary">
              Download Instead
            </a>
          </div>
        )}
      </div>
    </div>
  );
}

export default PreviewModal;